import React from 'react';
import type { UpgradeId, UpgradeOption } from '../game/types';

interface UpgradeModalProps {
  options: UpgradeOption[];
  onChoose: (id: UpgradeId) => void;
}

export function UpgradeModal({ options, onChoose }: UpgradeModalProps) {
  return (
    <div className="modal-backdrop">
      <section className="modal" role="dialog" aria-modal="true" aria-labelledby="upgrade-title">
        <div className="modal-header"><h2 id="upgrade-title">关卡完成 · 选择一项强化</h2></div>
        <div className="modal-body">
          <div className="upgrade-options">
            {options.map((option) => (
              <button key={option.id} className="upgrade-card" onClick={() => onChoose(option.id)}>
                <div className="emoji">{option.emoji}</div>
                <h3>{option.name}</h3>
                <p>{option.description}</p>
              </button>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
